export default {
  inject: ['load'],
  data() {
    return {
      allConsciousnessLevelsForOther: [],
      consciousnessLevel: null,
    };
  },
  methods: {
    getListOfConsciousnessLevelsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllConsciousnessLevels').then(() => {
        if (this.$store.state.consciousnessLevelModule.successFlag) {
          this.allConsciousnessLevelsForOther =
            this.$store.state.consciousnessLevelModule.allConsciousnessLevels;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.consciousnessLevelModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfConsciousnessLevelsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getConsciousnessLevelFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getConsciousnessLevel', id).then(() => {
        if (this.$store.state.consciousnessLevelModule.successFlag) {
          this.consciousnessLevel = this.$store.state.consciousnessLevelModule.consciousnessLevel;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.consciousnessLevelModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getConsciousnessLevelFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.consciousnessLevelModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
